import React from 'react'


import about1 from './about1.png'
import whatsapp1 from './whatsapp1.jpg'
import about5 from './about5.jpg'
import Become from './Become'
import Plan from './Plan'

import Super from './Super'



const About=() =>{
  return (
    <div>
      
      <>
      <div id='about1' className=''>

      
      <div className='container my-3 text-center'>
        <div className='row'>
          <div className='col-md-4'>
            <img src={about1} alt=''/>

          </div>
          <div className='col-md-4'>
            <h1>About Fundguard</h1>
            <p>FundGuard is launched by Ram Kumar Sahu to offer Insurance and financial products services to clients in Delhi NCR.</p>
            <div className='mt-3 mb-3' >
          <a  href='/' className='btn btn-success'>Contact</a>

        </div>
           <a href='https://wa.me/917632908427'> <img style={{width:'50px',height:'50px',borderRadius:'50%'}} src={whatsapp1} alt=''/></a>

          </div>
          <div className='col-md-4'>
            <img  src={about5} alt=''/>
          

          </div>

        </div>

      </div>
     

      </div>
      <div id='bnt' className='bnt'>

      
      < Become/>
          <Plan/>
          
          <Super/>
          </div>
         
  
      </>
    </div>
  )
}

export default About
